<template>
  <div class="page zhuanti-page">
    <div class="hero"  id="section1">
      <img src="@/assets/images/zhuanti/banner.jpg" alt="" />
      <div class="hero-bg"></div>
    </div>
    <div class="main-width-container hero-inner">
        <div class="hero-card">
          <div class="hero-left">
            <div class="badge">
              <img src="@/assets/images/zhuanti/banner-left-icon.png" alt="" />
            </div>
            <div class="hero-meta">
              <img src="@/assets/images/zhuanti/banner-left.png" alt="" />
              <!-- <div class="hero-title-jieci"> 第 40 届</div>
              <div class="hero-title">全国青少年科技创新大赛</div>
              <div class="hero-subtitle">以 “勇担时代使命，助力高水平科技自立自强” 为主题</div>
              <div class="hero-kv">
                <div class="kv-item">
                  <div class="kv-k">时间</div>
                  <div class="kv-v">07.15 - 07.20</div>
                </div>

              </div> -->
            </div>
          </div>

          <div class="hero-right">
            <div class="hero-info">
              <div class="info-row" v-for="(item, idx) in overviewList" :key="idx" @click="jumpdetail('article', item.id)">
                <div class="info-k">{{ item.topicName }}</div>
                <div class="info-v">{{ item.releaseTime }}</div>
              </div>
            </div>
          </div>
        </div>

    
    </div>
 
    <div class="main-width-container" style="width:100%;background: #F8FBFE; padding-top: 10px;">
      <div class="section" id="photos" style="margin-top:0px;" >
        <div class="section-title">
          <img src="@/assets/images/zhuanti/zhuanti-title-2.png" alt="" class="title-icon"/>
        </div>
        <div class="schedule">
          <!-- <div class="section-title section-border">
            <span class="text">第40届全国青少年科技创新大赛现场活动日程</span>
          </div> -->
          <div class="schedule-main">
            <div class="schedule-row">
                <div class="schedule-row-date">
                  <p>7月25日</p>
                  <p><span>星期六</span></p>
                </div>
                <div class="schedule-row-date-icon"></div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>08:00 - 17:00</span></p>
                  <p>参赛代表报道</p>
                </div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>19:00 - 21:00</span></p>
                  <p>领队会<span class="schedule-line">|</span>破冰活动</p>
                </div>
                <div class="schedule-row-date"></div>
              </div>
                <div class="schedule-row">
                  <div class="schedule-row-date">
                    <p>7月26日</p>
                    <p><span>星期日</span></p>
                  </div>
                  <div class="schedule-row-date-icon"></div>
                  <div class="schedule-row-date schedule-row-date-color">
                    <p><span>08:00 - 12:30</span></p>
                    <p>个人挑战赛</p>
                  </div>
                  <div class="schedule-row-date schedule-row-date-color">
                    <p><span>14:00 - 17:00</span></p>
                    <p>科技文化主题参观</p>
                  </div>
                  <div class="schedule-row-date schedule-row-date-color">
                    <p><span>20:00 - 21:00</span></p>
                    <p>团队挑战抽签</p>
                  </div>
              </div>
              <div class="schedule-row">
                <div class="schedule-row-date">
                  <p>7月27日</p>
                  <p><span>星期一</span></p>
                </div>
                <div class="schedule-row-date-icon"></div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>08:00 - 18:00</span></p>
                  <p>团队挑战赛</p>
                </div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>08:00 - 17:00</span></p>
                  <p>国际代表人文参观</p>
                </div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>18:00 - 21:00</span></p>
                  <p>科技自立自强报告</p>
                </div>
              </div>
              <div class="schedule-row">
                <div class="schedule-row-date">
                  <p>7月28日</p>
                  <p><span>星期二</span></p>
                </div>
                <div class="schedule-row-date-icon"></div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>08:00 - 12:00</span></p>
                  <p>成长支持计划”双选会”</p>
                </div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>14:00 - 17:00</span></p>
                  <p>成长支持计划”双选会”</p>
                </div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>19:00 - 21:00</span></p>
                  <p>"学长说”创新故事分享会<span class="schedule-line">|</span>国际青少年文化交流活动</p>
                </div>
              </div>
              <div class="schedule-row">
                <div class="schedule-row-date">
                  <p>7月29日</p>
                  <p><span>星期三</span></p>
                </div>
                <div class="schedule-row-date-icon"></div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>10:00 - 11:30</span></p>
                  <p>闭幕活动</p>
                </div>
                <div class="schedule-row-date schedule-row-date-color">
                  <p><span>下午</span></p>
                  <p>代表离会</p>
                </div>
                <div class="schedule-row-date"></div>
              </div>
          </div>
        </div>
        <div class="photo-grid">
          <div class="photo-card" v-for="(item, idx) in photoList" :key="idx" @click="jumpdetail('photo', item.id, item.groupType)">
            <div class="photo-img" :style="{ background: item.color }">
               <img :src="item.coverUrl" alt=""/>
            </div>
            <div class="photo-body">
              <div class="photo-title">{{ item.topicName }}</div>
              <div class="photo-meta">
                <div class="meta-item" v-if="item.groupType == 2 && item.imageUrl">
                 
                  <img src="@/assets/images/zhuanti/icon-1.png" alt="" class="small-icon"/>
                 
                  <span>{{ JSON.parse(item.imageUrl).length }}</span>张
                </div>
                <div class="meta-item">
                  <img src="@/assets/images/zhuanti/icon-2.png" alt="" class="small-icon"/>
                  <span>{{ item.clicks }}</span>次浏览
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" id="plan">
        <div class="section-title section-border">
          <span class="text">青少年成长支持计划</span>
        </div>
        <div class="section-subtitle">通知公告</div>
        <div class="plan-grid">
          <div class="plan-card" v-for="(item, idx) in planList" :key="idx" @click="jumpdetail('article', item.id, item.groupType, item.webLink)">
            <div class="plan-desc">{{ item.topicName }}</div>
            <div class="plan-opts">
              <span>{{ item.releaseTime }}</span>
              <button class="btn-link plan-btn" type="button">
                查看详情 <img src="@/assets/images/zhuanti/zhuanti-arrow.png" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="section" id="awards">
        <div class="hero-nav hero-nav-awards">
            <span
              v-for="item in navList1"
              :key="item.id"
              href="##"
              class="nav-item"
              :class="{active: item.id == activeId} "
              @click.prevent="getawardList(item.id)"
            >
              {{ item.label }}
            </span>
        </div>

        <div class="award-wrap">
          <div class="award-controller award-prev">
            <img src="@/assets/images/zhuanti/arrow-left.png" alt="" class="arrow"/>
          </div>
          <div class="award-controller award-next">
            <img src="@/assets/images/zhuanti/arrow-right.png" alt="" class="arrow"/>
          </div>

          <swiper :options="awardSwiperOption" class="award-swiper">
            <swiper-slide v-for="(i,index) in [1,2,3]" :key="i">
              <a class="award-card" v-for="(item, idx) in awardList.slice(index*6, i*6)" :key="idx" :href="item.webLink" target="_blank">
                <div class="award-title">
                  <div class="award-trophy-title">{{ item.topicName }}</div>
                  <div class="award-trophy">{{ item.relevantUnits }}</div>
                </div>
                <div class="award-desc">{{ item.topicContent }}</div>
                <div class="award-foot">
                  <div class="award-logo">
                    <img :src="item.logo" alt="" />
                  </div>
                </div>
              </a>
            </swiper-slide>
          </swiper>
          <!-- <div class="award-pagination"></div> -->
        </div>

        <div class="more-wrap">
          <button class="btn-more" type="button"><a target="_blank"  href="https://qsnkjcxds-kp.cast.org.cn/castic/specialaward">更多青少年成长支持计划</a></button>
        </div>
      </div>

      <div class="section-title">
        <img src="@/assets/images/zhuanti/zhuanti-title-1.png" alt="" class="title-icon"/>
      </div>
      <div class="hero-nav">
        <span
          v-for="item in navList"
          :key="item.id"
          href="##"
          class="nav-item"
          :class="{active: item.id == activeId2} "
          @click.prevent="getcompetitionList(item.id)"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
    <div class="main-width-container">
      <div class="section" id="schedule" style="padding-bottom: 30px; position: relative;">
    
          <div class="award-controller schedule-prev">
            <img src="@/assets/images/zhuanti/arrow-left.png" alt="" class="arrow"/>
          </div>
          <div class="award-controller schedule-next">
            <img src="@/assets/images/zhuanti/arrow-right.png" alt="" class="arrow"/>
          </div>

          <swiper :options="scheduleSwiperOption" class="award-swiper">
            <swiper-slide v-for="(i,index) in [1,2,3]" :key="index">
              <div class="schedule-grid">
                <a class="schedule-card" v-for="(card, idx) in scheduleCards.slice(index*4, i*4)" :key="idx" target="_blank" :href="card.webLink">
                    <div class="card-title">{{ card.topicName }}</div>
                    <div class="card-desc">{{ card.contestDes }}</div>
                    <div class="card-table-middle">
                      <div class="row">
                        <strong>主办单位：</strong>
                        {{ card.relevantUnits }}
                      </div>
                      <div class="row">
                        <strong>地      区：</strong>
                        {{ card.area }}
                    </div>
                    <div class="row">
                      <strong>参赛对象：</strong>
                      {{ card.contestant }}
                  </div>
                  <div class="row">
                    <strong>联系咨询：</strong>
                    {{ card.consult }}
                </div>
                    </div>
                    <div class="card-table">
                      <p><strong>举办周期：</strong></p>
                      <div class="row">
                        <div class="k">{{ card.cycle }}</div>
                        <div class="v">申报</div>
                      </div>
                      <div class="row">
                        <div class="k">{{ card.cycleInit }}</div>
                        <div class="v">初审</div>
                      </div>
                      <div class="row">
                        <div class="k">{{ card.cycleFinal }}</div>
                        <div class="v">终评</div>
                      </div>
                    </div>
                    <div class="card-actions">
                      <button class="btn-link" type="button">
                        了解更多  <img src="@/assets/images/zhuanti/zhuanti-arrow.png" alt="" />
                      </button>
                    </div>
                  </a>    
              </div>
            </swiper-slide>

          </swiper>
      
     

        <div class="more-wrap">
          <button class="btn-more" v-if="activeId2==1" type="button"><a target="_blank" href="https://www.cyscc.org/castic/#/news/article/249847">查看更多赛事</a></button>
          <button class="btn-more" v-if="activeId2==2" type="button"><a target="_blank" href="https://www.cyscc.org/castic/#/news/article/249846">查看更多赛事</a></button>
        </div>
      </div>
    </div>
    <div class="ad">
      <a class="ad-row" href="#section1">
        <img src="@/assets/images/zhuanti/zhuanti-window-1.png" alt="">
        <span>通知信息</span>
      </a>
      <a class="ad-row" href="#photos">
        <img src="@/assets/images/zhuanti/zhuanti-window-3.png" alt="">
        <span>现场活动</span>
      </a>
      <a class="ad-row" href="#plan">
        <img src="@/assets/images/zhuanti/zhuanti-window-5.png" alt="">
        <span>成长支持</span>
      </a>
      <a class="ad-row" href="#schedule">
        <img src="@/assets/images/zhuanti/zhuanti-window-2.png" alt="">
        <span>关联赛事</span>
      </a>
      <a class="ad-row" href="https://qsnkjcxds-kp.cast.org.cn/front/home" target="_blank">
        <img src="@/assets/images/zhuanti/zhuanti-window-4.png" alt="">
        <span>注册参赛</span>
      </a>
    </div>
  </div>
</template>

<script>
import { getfortyTopicList, addClicks } from '../../api/zhuanti'
export default {
  name: 'ZhuantiIndex',
  data () {
    return {
      activeId:'1',
      activeId2: '1',
      navList: [
        { id: '1', label: '少年组赛事' },
        { id: '2', label: '青年组赛事' },
      ],
      navList1: [
        { id: '1', label: '少年组支持计划' },
        { id: '2', label: '青年组支持计划' },
        { id: '3', label: '全组别支持计划' },
      ],
      overviewList: [],
      scheduleCards: [
      ],
      photoList: [
      ],
      planList: [
      ],
      awardList: [
      ],
      scheduleSwiperOption: {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        navigation: {
          nextEl: '.schedule-next',
          prevEl: '.schedule-prev'
        },
      },
      awardSwiperOption: {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        navigation: {
          nextEl: '.award-next',
          prevEl: '.award-prev'
        },
      }
    }
  },
  created () {
    this.getHistoryList();
    this.getphotoList();
    this.getplanList();
    this.getawardList(1);
    this.getcompetitionList(1);
  },
  methods: {
    resetSwiper() {
        if (this.swiper) { // 检查 Swiper 是否已初始化
          this.swiper.destroy(); // 销毁 Swiper 实例
        }
        // 这里可以更新数据，例如 this.slides = newSlides;
        this.$nextTick(() => { // 使用 $nextTick 来确保 DOM 更新完成后再初始化 Swiper
          this.swiper = new Swiper('.swiper-container', this.swiperOptions); // 重新初始化 Swiper，注意这里是原生方式，通常在 Vue 中不需要这么做，除非你特别需要这样操作。在 Vue 中，你应该直接在模板中使用 <swiper> 组件并更新相关数据即可。如果你确实需要这样做，请确保选择正确的容器。例如：new Swiper('.swiper-container', this.swiperOptions); 但通常不推荐这样做，直接在模板中更新数据即可。更好的方式是在数据变化后让 Vue 自动更新 DOM。例如：this.slides = newSlides; 然后 Swiper 会自动根据新的 slides 来调整。
        });
      },
     // 关联赛事
     async getcompetitionList (type) {
      this.activeId2 = type;
      const res = await getfortyTopicList(12, 2,  type)
      this.scheduleCards = res.data.list;
      
    },
    // 获取奖项
    async getawardList (type) {
      this.activeId = type;
      const res = await getfortyTopicList(18, 5,  type)
      this.awardList = res.data.list;
      
    },
    // 获取通知信息
    async getHistoryList () {
      const res = await getfortyTopicList(6, 1,  1)
      this.overviewList = res.data.list;
      
    },
     // 获取活动现场
     async getphotoList () {
      const res = await getfortyTopicList(6, 3,  1)
      this.photoList = res.data.list;
      
    },
     // 青少年成长支持计划
     async getplanList () {
      const res = await getfortyTopicList(3, 4,  1)
      this.planList = res.data.list;
      
    },
    async jumpdetail(type, id, grouptype, link){
      await addClicks(id);
      if (type =='article') {
        if (link) {
          window.open(link);
        } else {
          this.$router.push({
            path: '/home/article/'+id+ '?source=zt',

          })
        }
       
      }
      if (type =='photo') {
        if (grouptype == 1) { //视频
          this.$router.push({
            path: 'news/video/'+id+ '?source=zt',
          })
        }
        else if (grouptype == 2) { //照片
          this.$router.push({
            path: '/news/photo/'+id+ '?source=zt',
          })
        } else{
          this.$router.push({
            path: '/home/article/'+id+ '?source=zt',
          })
        }


       
      }
    }
  }
}
</script>

<style scoped lang="less">
.zhuanti-page {
  background: #ffffff;
  padding-bottom: 0;
}

.hero {
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 520px;
  text-align: center;
  background: #F8FBFE;
}
.hero-inner{
  width: 100%;
  background: #F8FBFE;
  text-align: center;
}
.hero  img{
  height: 100%;
  margin: 0 auto;
}
.hero-bg {
  position: absolute;
  height: 30px;
  background: linear-gradient(180deg, #f8fbfe00 0%, #F8FBFE 100%);
  bottom: 0;
  left: 0;
  right: 0;
}

.hero-inner {
  position: relative;
}
.hero-card {
  border-radius: 12px;
  border: 1px solid #FFF;
  background: linear-gradient(180deg, #F4F8FE 0%, #FFF 100%);
  box-shadow: 0 4px 4px 0 #e8f0fb80;
  display: flex;
  justify-content: space-between;
  display: flex;
  width: 1200px;
  padding:20px  40px;
  align-items: center;
  margin: 0 auto;
  position: relative;
    top: -40px;
}

.hero-left {
  display: flex;
  align-items: center;
  width: 528px;
  margin-right: 70px;
}
.badge {
  width: 240px;
  height: 220px;
  margin-right: 14px; 
  margin-top: 10px;
}
.badge img{
  width: 100%;
  height: 100%;
}

.hero-meta img{
  height: 202px;
}
.hero-title-jieci{
  color: #333333;
  font-size: 20px;
  margin-bottom: 8px;
}
.hero-title {
  font-size: 28px;
  font-weight: 800;
  color: #355FD5;
  line-height: 1;
}
.title-icon{
  width: 290px;
}

.hero-subtitle {
  margin-top: 8px;
  font-size: 12px;
  color: #333333;
  padding: 4px 10px;
  background-color: #E6EEFF;
  border-radius: 4px;
}
.hero-kv {
  margin-top: 18px;
  display: flex;
  gap: 16px;
}
.kv-item {
  background: #f3f8ff;
  border-radius: 10px;
  padding: 10px 12px;
  min-width: 160px;
}
.kv-k {
  color: #3d7dcd;
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
  letter-spacing: 1px;
}
.kv-v {
  margin-top: 4px;
  font-size: 18px;
  line-height: 24px;
  color: #1a2b49;
  font-weight: 700;
}

.hero-right {
  flex: 1;
  display: flex;
  align-items: center;

}
.hero-info {
  width: 100%;
  height: 220px;
  padding: 20px 0;
}
.info-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  position: relative;
  padding-left: 10px;
  cursor: pointer;
}
.info-row::before{
  display: block;
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 4px;
  background-color: #355FD5;
  position: absolute;
  left: 0;
  top: 18px;
}
.info-k {
  width: 410px;
  height: 22px;
  color: #333333;
  font-weight: 400;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.info-v {
  min-width: 80px;
  color: #999999;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  overflow: hidden;
}

.hero-nav {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
.arrow{
  width: 24px;
  height: 48px;
}
.nav-item {
  display: inline-block;
  text-align: center;
  width: 200px;
  height: 40px;
  color: #355FD5;
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  background-image:url("../../assets/images/zhuanti/nav-bg.png");
  background-position: center top;
  background-size: 115% 105%;
  cursor: pointer;
}
.nav-item.active {
  background-image:url("../../assets/images/zhuanti/nav-bg-active.png");
  background-position: center top;
  background-size: 115% 105%;
}
#awards{
  width: 1280px;
  padding-bottom: 64px;
}
.hero-nav-awards{
  width: 440px;
  padding: 4px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #EBEDF0;
  background: #FFF;
  margin: 0 auto 32px;
}
.hero-nav-awards .nav-item{
  width: 144px;
  height: 38px;
  font-size: 16px;
  border-radius: 4px;
  text-align: center;
  font-weight: 400;
  color: #333333;
}
.hero-nav-awards .nav-item.active{
  background: #355FD5;
  color: #fff;
}
.section{
  width: 1200px;
  margin: 40px auto 0;
}
.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
}
.schedule{
  border-radius: 8px;
  border: 1px solid #EBEDF0;
  background: #FFF;
  padding: 24px;
  margin-top: 32px;
}
.section-border{
  border-bottom: 1px solid #EBEDF0;
  margin-bottom: 32px;
}
.section-subtitle{
  color: #333333;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}
.section-title .text {
  font-weight: 700;
  color: #333333;
  font-size: 24px;
  font-weight: 700;
  padding-bottom: 20px;
  position: relative;
}
.section-title .text::before{
  display: inline-block;
  content: "";
  width: 216px;
  height: 4px;
  background: #355FD5;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.schedule-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px 18px;
  margin: 0 auto;
}
.schedule-card {
  display: block;
  width: 540px;
  height: 320px;
  background: #fff;
  border: 1px solid #EBEDF0;
  border-radius: 8px;
  padding:24px;

}
.schedule-card .card-title {
  font-size: 16px;
  font-weight: 800;
  color: #1a2b49;
}
.schedule-card .card-desc {
  height: 40px;
  line-height: 20px;
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #5e6b7d;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  
}
.card-table-middle{
   font-size: 12px;
   color: #333333;
   display: flex;
   flex-wrap: wrap;
   padding-bottom: 8px;
   border-bottom: 1px solid #EBEDF0;
}
.card-table-middle .row{
  width: 50%;
  margin-bottom: 8px;
}
.card-table {
  margin-top: 16px;
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between
}
.card-table p{
  width: 100%;
  margin-bottom: 12px;
}
.card-table .row {
  width: 169px;
  height: 52px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background: #F5F6FA;
  padding: 8px 0;
  border-radius: 4px;
}

.card-table .k {
  width: 100%;
  color: #355FD5;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 1px;
  text-align: center;
}
.card-table .v {
  width: 100%;
  color: #333333;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
}
.small-icon{
  width: 13px;
  margin-left: 20px;
}
.card-actions {
  margin-top: 16px;
  display: flex;
  
}
.btn-link {
  width: 106px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #eef5ff;
  color: #355FD5;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
}
.btn-link img{
  width: 14px;
  margin-left: 5px;
}

.more-wrap {
  display: flex;
  justify-content: center;
  padding-top: 18px;
}
.btn-more {
  display: flex;
  min-width: 120px;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background:#355FD5;
  color: #ffffff;
 font-size: 14px;
 font-style: normal;
 font-weight: 400;
 border:none;
}
.btn-more a{
  color: #fff;
}
.btn-more:hover {
  filter: brightness(0.98);
}

.photo-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 32px;
}
.photo-card {
  width: 373px;
  height:270px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}
.photo-img {
  height:210px;
  background-color: #dedede;
}
.photo-img img{
  width: 100%;
  height: 210px;
  object-fit: cover;
}
.photo-body{
  display: flex;
  height: 60px;
  align-items: center;
  justify-content: space-between;
}
.photo-title {
  font-size: 14px;
  font-weight: 800;
  color: #1a2b49;
  height: 20px;
  width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}
.photo-meta {
  color: #7b889a;
  font-size: 12px;
  display: flex;
}

.meta-item{
  display: flex;
  align-items: center;
}
.meta-item span{
  color: #355fd5;
 font-size: 16px;
 padding: 0 4px;
}
.plan-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}
.plan-card {
  width: 384px;
  height: 98px;
  background: #fff;
  border-radius: 8px;
  padding: 24px 20px;
  cursor: pointer;
}

.plan-title {
  font-size: 16px;
  font-weight: 800;
  color: #1a2b49;
  letter-spacing: 1px;
}
.plan-desc {
  font-size: 16px;
  color: #5e6b7d;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.plan-opts{
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
  font-size: 14px;
  color: #999999;
}
.plan-btn {
  background-color: transparent;
  font-size: 14px;
  font-weight: 400;
  color: #355FD5;
}


.award-wrap {
  margin: 0 auto;
  position: relative;
  padding: 0 0px 18px;
}
.award-controller {
  position: absolute;
  top: 50%;
  margin-top: -25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  font-size: 26px;
}
.award-prev {
  left: 0;
}
.schedule-prev{
  left: -40px;
}
.schedule-next{
  right: -40px;
}
.award-next {
  right: 0;
}
.award-swiper {
  width: 1200px;
  padding: 8px 0 22px;
}
.award-swiper .swiper-slide{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.award-card {
  display: block;
  width: 334px;
  height: 264px;
  background: linear-gradient(180deg, #FFF8E5 0%, #FFF 100%);
  box-shadow: 0 4px 4px 0 #e8f0fb80;
  border-top: 6px solid #E6A600;
  border-radius: 8px;
  overflow: hidden;
  padding: 24px 24px;
  margin-bottom: 24px;
  cursor: pointer;
}
.award-trophy {
  font-size: 12px;
 font-style: normal;
 font-weight: 400;
}
.award-trophy-title{
  width: 100%;
  color: #333333;
  font-size: 20px;
 font-style: normal;
 font-weight: 600;
 text-align: center;
}
.award-title {
  width: 240px;
  height: 58px;
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  letter-spacing: 1px;
  position: relative;
  margin: 0 auto;
}
.award-title::before{
  display: inline-block;
  content: "";
  width: 24px;
  height: 58px;
  background-image:url("../../assets/images/zhuanti/zhuanti-cb-left.png");
  background-size: 100%;
  position: absolute;
  left: 0;
  top:0;
}
.award-title::after{
  display: inline-block;
  content: "";
  width: 24px;
  height: 58px;
  background-image:url("../../assets/images/zhuanti/zhuanti-cb-right.png");
  background-size: 100%;
  position: absolute;
  right: 0;
  top: 0;
}
.award-desc {
  height: 84px;
  margin-top: 25px;
  font-size: 14px;
  color: #5e6b7d;
  line-height: 21px;
  text-align: left;
  height: 84px;
  display: -webkit-box;           /* 必须：启用弹性伸缩盒模型 */
  -webkit-box-orient: vertical;   /* 必须：设置为垂直方向 */
  -webkit-line-clamp: 4;          /* 关键：限制最多显示4行 */
  overflow: hidden;               /* 必须：隐藏溢出内容 */
  text-overflow: ellipsis;        /* 可选：兜底省略效果 */
}
.award-foot {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #EBEDF0;
  padding-top: 24px;
}
.award-logo {
  width: 100%;
  height: 48px;
  text-align: center;
}
.award-logo img{
  height: 100%;
}
.award-pagination {
  text-align: center;
  padding-top: 12px;
}
/deep/.award-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  margin: 0 8px;
}
/deep/.award-pagination .swiper-pagination-bullet-active {
  background: var(--main-color-2);
}
.schedule-main{
  width: 100%;
  margin-top: 12px;
  overflow: hidden;
}
.schedule-row{
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 0;
}
.schedule-row-date{
   min-width: 65px;
   font-size: 16px;
   font-weight: 600;
   color: #355fd5;
   position: relative;
}

.schedule-row-date-icon{
  width: 3px;
  height: 12px;
  background-color: #355FD5;
  transform:  rotate(14deg);
  margin: 0 40px;
}
.schedule-row-date.schedule-row-date-color span{
  color: #999999;
}
.schedule-row-date.schedule-row-date-color .schedule-line{
  padding: 0 16px;
  color: #DCDEE0;
}
.schedule-row-date.schedule-row-date-color{
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  width: 230px;
  height: 58px;
  background: #F5F6FA;
  padding: 8px 16px;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 24px;
}
.schedule-row-date.schedule-row-date-color:nth-last-child(1){
  margin-right: 0;
  flex: 1;
}
.schedule-row-date span{
  color: #666666;
 text-overflow: ellipsis;
 font-size: 12px;
 font-style: normal;
 font-weight: 400;
}
@media (max-width: 768px) {
  .zhuanti-page {
    min-width: auto;
    padding-bottom: 4.2rem;
  }
  .hero {
    padding: 0.3rem 0 0.35rem;
  }
  .hero-card {
    display: block;
    padding: 0.28rem 0.28rem 0.22rem;
    border-radius: 0.16rem;
  }
  .hero-left {
    
    align-items: flex-start;
  }
  .badge {
    width: 1.1rem;
    height: 1.1rem;
    border-radius: 0.16rem;
  }
  .badge-top,
  .badge-bottom {
    font-size: 0.22rem;
    line-height: 0.26rem;
  }
  .badge-num {
    font-size: 0.6rem;
    line-height: 0.64rem;
  }
  .hero-title {
    font-size: 0.42rem;
    line-height: 1.2;
  }
  .hero-subtitle {
    font-size: 0.24rem;
  }
  .hero-kv {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.14rem;
    margin-top: 0.22rem;
  }
  .kv-item {
    min-width: auto;
    padding: 0.14rem 0.14rem;
  }
  .kv-k {
    font-size: 0.2rem;
  }
  .kv-v {
    font-size: 0.28rem;
  }
  .hero-right {
    margin-top: 0.22rem;
  }
  .hero-info {
    border-left: none;
    padding: 0.12rem 0.04rem 0;
    border-top: 1px dashed rgba(61, 125, 205, 0.35);
  }
  .info-k,
  .info-v {
    font-size: 0.24rem;
    line-height: 0.36rem;
  }
  .hero-nav {
    margin-top: 0.2rem;
    gap: 0.12rem;
    flex-wrap: wrap;
    background-color: #fff;
  }
  .nav-item {
    font-size: 0.24rem;
    padding: 0.14rem 0.2rem;
    border-radius: 0.32rem;
  }

  .section {
    padding-top: 0.48rem;
  }
  .section-title {
    padding: 0.1rem 0 0.24rem;
  }
  .section-title .line {
    width: 1.4rem;
  }
  .section-title .text {
    font-size: 0.32rem;
  }

  .schedule-grid {
    grid-template-columns: 1fr;
    gap: 0.18rem;
  }
  .schedule-card {
    border-radius: 0.16rem;
    padding: 0.22rem 0.22rem 0.2rem;
  }
  .schedule-card .card-title {
    font-size: 0.3rem;
  }
  .schedule-card .card-desc {
    font-size: 0.26rem;
    line-height: 0.38rem;
  }
  .card-table .k {
    width: 0.9rem;
    font-size: 0.22rem;
  }
  .card-table .v {
    font-size: 0.26rem;
  }
  .btn-link {
    font-size: 0.24rem;
    padding: 0.14rem 0.18rem;
    border-radius: 0.16rem;
  }
  .btn-more {
    font-size: 0.28rem;
    padding: 0.18rem 0.42rem;
    border-radius: 0.44rem;
  }

  .photo-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.18rem;
  }
  .photo-img {
    height: 1.7rem;
  }
  .photo-body {
    padding: 0.2rem 0.2rem 0.22rem;
  }
  .photo-title {
    font-size: 0.26rem;
    min-height: 0.72rem;
  }
  .photo-meta {
    font-size: 0.22rem;
  }

  .plan-grid {
    grid-template-columns: 1fr;
    gap: 0.18rem;
  }
  .plan-card {
    padding: 0.22rem 0.22rem 0.2rem;
  }
  .plan-title {
    font-size: 0.3rem;
  }
  .plan-desc {
    font-size: 0.26rem;
    line-height: 0.38rem;
    min-height: auto;
  }
  .plan-btn {
    font-size: 0.28rem;
    border-radius: 0.16rem;
  }

  .award-wrap {
    padding: 0 0.18rem 0.22rem;
  }
  .award-controller {
    display: none;
  }
  .award-card {
    border-radius: 0.16rem;
    padding: 0.22rem 0.22rem 0.2rem;
  }
  .award-title {
    font-size: 0.3rem;
  }
  .award-desc {
    font-size: 0.26rem;
    line-height: 0.38rem;
  }

}
.ad{
  width: 130px;
  background: #F5F6FA;
  position: fixed;
  z-index: 999;
  right: 0;
  top: 530px;
}
.ad-row{
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #EBEDF0;
  cursor: pointer;
}
.ad-row:nth-of-type(2){
  border-top: 0;
  border-bottom: 0;
}
.ad-row span{
  display: inline-block;
  width: 32px;
  color: #333333;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  margin-left: 10px;
}
.ad-row img{
  width: 60px;
  height: auto;
}
.ad-row:hover{
  background-color: #fff;
  border-left: 4px solid #355FD5;
  box-sizing: content-box;
}
</style>
